"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPOSListingsV2 = void 0;
const shared_1 = require("@getgreenline/shared");
const url = (companyId, locationId) => `/api/v2/companies/${companyId}/locations/${locationId}/pos-listings`;
const getPOSListingsV2 = (companyId, locationId, filter) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(url(companyId, locationId), {
        params: Object.assign(Object.assign({}, filter), { updateDate: JSON.stringify(filter.updateDate) }),
    });
    return response.data;
});
exports.getPOSListingsV2 = getPOSListingsV2;
//# sourceMappingURL=pos-listing.js.map